import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { TableCell } from 'smartsuite-ui';
import { DateTimeFormats } from 'brock-date-time';
import { noDataIdentifier } from '../../../../shared/constants/constants';

export default function DateTime({ cellValue, dateTimeFormat, isLeftAligned }) {
    const formattedValue = !cellValue
        ? noDataIdentifier
        : moment(cellValue).format(dateTimeFormat);

    return (
        <TableCell cssClassModifiers={[isLeftAligned ? 'left-align' : '']}>
            {formattedValue}
        </TableCell>
    );
}

DateTime.propTypes = {
    cellValue: PropTypes.string.isRequired,
    dateTimeFormat: PropTypes.string,
    isLeftAligned: PropTypes.bool,
};

DateTime.defaultProps = {
    dateTimeFormat: DateTimeFormats.DATETIME,
    isLeftAligned: false,
};
